import { v4 as uuidv4 } from 'uuid'
import cogoToast from 'cogo-toast'
const { createSlice } = require('@reduxjs/toolkit')

const cartSlice = createSlice({
  name: 'cart',
  initialState: {
    cartItems: [],
  },
  reducers: {
    addToCart(state, action) {
      const product = action.payload
      state.cartItems.push({
        ...product,
        quantity: product.quantity ? product.quantity : 1,
        cartItemId: uuidv4(),
      })
      return
    },
    deleteFromCart(state, action) {
      state.cartItems = state.cartItems.filter((item) => item.cartItemId !== action.payload)
      cogoToast.success('Removed From Cart', { position: 'top-center' })
    },
    updateQuantity(state, action) {
      const product = action.payload
      if (product.action === 1) {
        state.cartItems = state.cartItems.map((item) => (item.cartItemId === product.cartItemId ? { ...item, quantity: item.quantity + 1 } : item))
        cogoToast.success('Item Added To Cart', { position: 'top-center' })
      } else {
        if (product.quantity === 1) {
          state.cartItems = state.cartItems.filter((item) => item.cartItemId !== product.cartItemId)
          cogoToast.success('Removed From Cart', { position: 'top-center' })
        } else {
          state.cartItems = state.cartItems.map((item) => (item.cartItemId === product.cartItemId ? { ...item, quantity: item.quantity - 1 } : item))
          cogoToast.success('Item Decremented From Cart', { position: 'top-center' })
        }
      }

    },
    deleteAllFromCart(state) {
      state.cartItems = []
    },
  },
})

export const { addToCart, deleteFromCart, updateQuantity, deleteAllFromCart } = cartSlice.actions
export default cartSlice.reducer
